import React, { useState } from 'react';
import {
  JaneDetailViewComponentMap,
  JaneDetailsViewActiveTabType,
} from 'components/JaneModal/views/JaneDetailsView/JaneDetailsView.types';
import {
  NavigationButton,
  NavigationButtonsWrapper,
  JaneDetailsNavigationWrapper,
} from 'components/JaneModal/views/JaneDetailsView/JaneDetailsView.styled';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import isUserAgencySelector from 'store/selectors/userSelectors/isUserAgencySelector';

export const JaneDetailsView = () => {
  const { t } = useTranslation();
  const isUserAgency = useSelector(isUserAgencySelector);
  const b2bTabs: [string, JaneDetailsViewActiveTabType][] = [
    ['General', 'GeneralTab'],
    ['Reviews', 'ReviewsTab'],
    ['Activity', 'ActivityTab'],
  ];

  const agencyTabs: [string, JaneDetailsViewActiveTabType][] = [
    ['General', 'GeneralTab'],
    ['Reviews', 'ReviewsTab'],
  ];

  const tabs = isUserAgency ? agencyTabs : b2bTabs;
  const [activeTab, setActiveTab] = useState<JaneDetailsViewActiveTabType>('GeneralTab');
  const ActiveTabComponent = JaneDetailViewComponentMap[activeTab];
  return (
    <div>
      <JaneDetailsNavigationWrapper>
        <NavigationButtonsWrapper>
          {tabs.map(([label, _enum]) => {
            return (
              <NavigationButton
                key={label}
                onClick={() => activeTab !== _enum && setActiveTab(_enum)}
                isActive={activeTab === _enum}
              >
                {t(`team_member:${label}`)}
              </NavigationButton>
            );
          })}
        </NavigationButtonsWrapper>
      </JaneDetailsNavigationWrapper>
      <ActiveTabComponent />
    </div>
  );
};
